import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import { clsx } from 'clsx';
import { ButtonProps } from './button';
import { getButtonClassName } from './helper';
import { iconButton } from './iconButton.css';
import { CircularProgress } from '@mui/material';
import { PropsWithChildren } from 'react';

type ToggleButtonProps =
  | {
      toggle?: never;
      selected?: never;
      iconSelected?: never;
    }
  | {
      toggle: true;
      selected: boolean;
      iconSelected: FontAwesomeIconProps['icon'];
    };

type IconButtonProps = ButtonProps &
  Partial<Pick<FontAwesomeIconProps, 'icon'>> &
  ToggleButtonProps & {
    iconClassName?: string;
    className?: string;
    loading?: boolean;
  };

export const IconButton = (p: PropsWithChildren<IconButtonProps>) => (
  <button
    type="button"
    {...p}
    className={getButtonClassName({
      ...p,
      color:
        (p.variant ?? 'filled') === 'filled' && p.toggle && !p.selected
          ? 'primaryTonal'
          : p.color,
      className: clsx(
        p.className,
        iconButton({
          toggle: p.toggle,
          selected: p.selected,
          color: p.color,
        }),
      ),
    })}
  >
    <>
      {p?.loading ? (
        <div>
          <CircularProgress
            size={16}
            style={{
              color: 'inherit',
            }}
          />
        </div>
      ) : p.icon ? (
        <FontAwesomeIcon
          icon={p.selected ? p.iconSelected : p.icon}
          className={p.iconClassName}
        />
      ) : null}
      {p.children}
    </>
  </button>
);
